import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';
import { QuestionService } from 'app/question/services/question.service';
import { QuestionBankListModel } from 'app/question/models/question-bank-list.model';
import { ModuleService } from 'app/module/services/module.service';

@Component({
    selector: 'app-module-question-bank-add',
    templateUrl: './module-question-bank-add.component.html',
    styleUrls: ['./module-question-bank-add.component.css']
})
export class ModuleQuestionBankAddComponent implements OnInit {
    errors: string[];
    auditTypes: AuditTypeModel[];
    questionBanks: QuestionBankListModel[];
    addModuleQuestionBankFrom: FormGroup;
    submitAttempt: boolean = false;
    @Input() moduleId: string;
    @Input() isEditMode: boolean = false;
    @Output() moduleQuestionBankAdded: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private questionService: QuestionService,
        private moduleService: ModuleService,
        private auditService: AuditService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTypes();
        this.getQuestionBanks();
        this.initializeForm();
        
    }

    initializeForm(): void {
        this.addModuleQuestionBankFrom = this.fb.group({
            moduleId: [this.moduleId],
            questionBankId: ['', Validators.required],
            auditTypeId: [''],
            zOrder: ['', Validators.required]
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    getQuestionBanks(): void {
        this.questionService.getAllQuestionBank().subscribe(result => {
            this.questionBanks = result;
        });
    }

    addQuestionBankToModule(): void {
        this.submitAttempt = true;
        if (this.addModuleQuestionBankFrom.valid) {
            const formValue = this.addModuleQuestionBankFrom.value;
            formValue.moduleId = this.moduleId;

            this.moduleService.addModuleQuestionBank(formValue).subscribe(
                result => {
                    this.moduleQuestionBankAdded.emit(result);
                    //this.addModuleQuestionBankFrom.reset();
                    this.initializeForm();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddQuestionBank(content) {
        this.modalService.open(content);
    }
}
